/**
 * Rule templates for database bootstrapping.
 *
 * Each template contains an array of pre-configured Geotab Rule objects
 * (stripped of server-generated IDs) that can be imported into a new database.
 * Rule presets let you select which rule sets to apply.
 */

import anzahlStoppsRules from "./rules/anzahlstopps.json";
import doorsRules from "./rules/doors.json";
import ecoRules from "./rules/eco.json";
import speedRules from "./rules/speed.json";

export interface RuleTemplate {
  id: string;
  label: string;
  description: string;
   
  rules: Record<string, any>[];
}

export interface RulePreset {
  id: string;
  label: string;
  templateIds: string[];
}

export const RULE_TEMPLATES: RuleTemplate[] = [
  {
    id: "eco",
    label: "ECO",
    description: "ECO driving rules (acceleration, braking, RPM, speed, comfort, idle, seatbelt)",
    rules: ecoRules,
  },
  {
    id: "doors",
    label: "Doors",
    description: "Door opening events (doors 1-4)",
    rules: doorsRules,
  },
  {
    id: "speed",
    label: "Speed",
    description: "Speed band rules (0-10, 10-20, ... 90+)",
    rules: speedRules,
  },
  {
    id: "anzahlstopps",
    label: "AnzahlStopps",
    description: "Stop counter (speed < 1 km/h for longer than 1s)",
    rules: anzahlStoppsRules,
  },
];

export const RULE_PRESETS: RulePreset[] = [
  {
    id: "all",
    label: "Standard",
    templateIds: ["eco", "doors", "speed"],
  },
  {
    id: "eco-only",
    label: "ECO",
    templateIds: ["eco"],
  },
  {
    id: "speed-only",
    label: "Speed",
    templateIds: ["speed"],
  },
];
